import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Row, Col, Modal, Button, Form } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getFeedbackDetail } from "../../../api/feedbackSupportService";
import { sendMail } from "../../../api/revenueService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { reportSchema } from "../../../validations/authSchema";
export default function ViewFeedback() {
  const [sent, setSent] = useState(false);
  const senttoggle = () => setSent(!sent);
  const [feedback, setFeedback] = useState({});
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const { feedbackId } = useParams();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(reportSchema),
  });

  const Talefiledata = [
    {
      id: 1,
      Title: 'Feedback ID',
      subtitle: feedback._id,   
    },
    {
      id: 2,
      Title: 'Username',
      subtitle: feedback.user,
    },
    {
      id: 3,
      Title: 'Feedback Type',
      subtitle: feedback.feedBackType,
    },
    {
      id: 4,
      Title: 'Date Submitted',
      subtitle: new Date(feedback.createdAt).toLocaleDateString(),
    },
    {
      id: 5,
      Title: 'Status',
      subtitle: <span className='Active badge'>{feedback.status}</span>,
    },
  ];

  useEffect(() => {
    if (feedbackId) {
      fetchFeedback(feedbackId);
    }
  }, [feedbackId]);

  const fetchFeedback = (feedbackId) => {
    getFeedbackDetail(feedbackId)
      .then((response) => {
        if (response.data) {
          const feedbackDetail = response.data;
          setFeedback(feedbackDetail);
        }
      })
      .catch((error) => console.error("Error fetching feedback details", error));
  };

  const handleSendMessage = (data) => {
    try {
      data.email = email;
      data.feedbackId = feedback._id;
      sendMail(data)
        .then((response) => {
          if (response.code === 200) {
            toast.success(response.message);
            setSent(false);
            setEmail('');
            setSubject('');
            setContent('');
          }else{
            toast.error(response.message);
          }
        })
        .catch((error) => {
          toast.error("Failed to send email. Please try again.");
        });
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleOpenSendMessage = () => {
    setEmail(feedback.email); 
    setSent(true); 
  };


  return (
    <React.Fragment>
      <Card>
        <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
          <h5>Feedback Details</h5>
          <Link className="btn btn-primary-light d-inline-flex align-items-center justify-content-center px-4 min_width140" to="/feedback-support">Back</Link>
        </Card.Header>
        <Card.Body className="taledtl_div mt-3">
          <Row>
            <Col md="12">
              <div className="talefile_list">
                {Talefiledata.map((item) => (
                  <div className="tablefilelist_grid" key={item.id}>
                    <h4>{item.Title}</h4>
                    <p>{item.subtitle}</p>
                  </div>
                ))}
              </div>
              {/* {showSecondDiv && ( */}
              <div className="reportresponse_div">
                <h3 className="reportresponse_head">Response History</h3>
                <div className="reportresponse_box">
                  {feedback.adminReply ? (
                    <>
                      <h4>Admin Reply</h4>
                      <p>{feedback.adminReply}</p>
                    </>
                  ) : (
                    <p>No reply yet</p>
                  )}
                </div>
              </div>
                {/* )} */}
              <div className="mt-3">
                <Button className="btn btn-primary px-4 mt-2 min_width140" onClick={handleOpenSendMessage}>
                  Send
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Modal show={sent} onHide={senttoggle} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="modalhead">Send Message</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(handleSendMessage)}>
            <Form.Group className="mb-3 form-group">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter subject"
                {...register("subject")}
              />
              {errors.subject && (
                <p className="text-danger">{errors.subject.message}</p>
              )}
            </Form.Group>
            <Form.Group className="mb-3 form-group">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter message"
                {...register("content")}
              />
              {errors.content && (
                <p className="text-danger">{errors.content.message}</p>
              )}
            </Form.Group>
            <Button onClick={senttoggle} className="btn btn-secondary px-4 min_width110">
              Cancel
            </Button>
            <Button type="submit" className="btn btn-primary px-4 mx-2 min_width110">
              Send
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <ToastContainer />
    </React.Fragment>
  );
}
